import { Loading } from 'app/components';
import { Suspense } from 'react';

const TSuspense = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

export default TSuspense;
